import { action, observable } from 'mobx';
import ILogTableStore from 'shared/containers/MobXLogTable/ITableStore';
import HistorySystemUsageModel from 'shared/models/history/HistorySystemUsageModel';
import HistorySystemUsageSearchModel from 'shared/models/history/HistorySystemUsageSearchModel';
import { RootStore } from 'shared/stores/RootStore';
import HistoryService from 'shared/services/HistoryService';
import uuid from 'uuid';
import AppConst from 'shared/utils/AppConst';
import AppHelper from 'shared/utils/AppHelper';

export class HistorySystemUsageStore implements ILogTableStore<HistorySystemUsageModel> {
  @observable
  inProgress: boolean;

  rootStore: RootStore;
  @observable
  searchModel: HistorySystemUsageSearchModel;

  @observable
  dataSource: HistorySystemUsageModel[];

  /** Actual number of records in DB */
  @observable
  totalCount: number;

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.resetStore();
  }

  @action
  export = async () => {
    try {
      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.exportSystemUsageHistories(params);
      this.rootStore.apiHandleStore.handleApiExport(response);
    } catch (error) {
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  find = async () => {
    try {
      this.inProgress = true;
      this.dataSource = Array<HistorySystemUsageModel>();
      const histories = Array<HistorySystemUsageModel>();
      const params = this.parseSearchModelToApiParams();
      const response = await HistoryService.findSystemUsageHistories(params);
      const { isSuccessful } = response.data.header;
      if (!isSuccessful) {
        this.inProgress = false;
        this.rootStore.apiHandleStore.handleApiFail(response.data.header);
        return;
      }

      const { empty, totalCount, results } = response.data.data;
      const data = results || [];
      const length = data ? data.length : 0;
      for (let index = 0; index < length; index++) {
        const element = data[index];
        element.no = index + 1;
        element.id = uuid.v4();
        element.changeStatus = AppConst.ActionType.READ;
        histories.push(element);
      }
      this.totalCount = totalCount || 0;
      this.dataSource = histories;
      this.inProgress = false;
    } catch (error) {
      this.inProgress = false;
      this.rootStore.apiHandleStore.handleApiError(error);
    }
  };

  @action
  setDataSource(dataSource: HistorySystemUsageModel[]) {
    this.dataSource = dataSource;
  }

  getDataSource() {
    return this.dataSource;
  }

  /**
   * @Override
   */
  resetSearchModel() {
    this.searchModel = {      
      userName: '',
      empNo: '',
      offset: AppConst.LOG_DEFAULT_OFFSET,
      limit: AppConst.LOG_TABLE_PAGE_SIZE,
      termFrom: 0,
        termTo: 0,
        regDateFrom: 0,
        regDateTo: 0
    };
  }

  parseSearchModelToApiParams = () => {
    const { userName, empNo, termFrom, termTo, regDateFrom, regDateTo, offset } = this.searchModel;
    return {
      userName,
      empNo,      
      termFrom: this.trimDate(termFrom),
      termTo: this.trimDate(termTo),
      regDateFrom: this.trimDate(regDateFrom),
      regDateTo: this.trimDate(regDateTo),
      offset,
      limit: AppConst.LOG_TABLE_PAGE_SIZE
    };
  };

  /**
   * @Override
   */
  @action
  resetStore = () => {
    this.totalCount = 0;
    this.setDataSource(Array<HistorySystemUsageModel>());
    this.resetSearchModel();    
  };

  trimDate = (dateValue: number) => {
    return dateValue > 0 ? dateValue : '';
  };
}
